// @flow
import type {
  UsersState,
} from '../types'

// Initial state and reducer maps
import { initialState as usersState } from 'fc-users'
import { initialState as authenticatedUserState } from 'fc-authenticated-user'

// Local
export const initialState: UsersState = {
  ...usersState,
  ...authenticatedUserState,
}

export default initialState
